// Query param keys
export const AGE_VERIFICATION_PROCESS_MODAL_QUERY_PARAM_KEY = 'age-verification-process-modal'
export const AGE_VERIFICATION_REQUIRED_MODAL_QUERY_PARAM_KEY = 'age-verification-required-modal'
export const AGE_VERIFICATION_SUCCESS_MODAL_QUERY_PARAM_KEY = 'age-verification-success-modal'
export const QUERY_PARAM_KEY_VERIFICATION_METHOD = 'verificationMethod'
export const QUERY_PARAM_KEY_VERIFICATION_PLATFORM = 'verificationPlatform'
export const QUERY_PARAM_KEY_QR_TOKEN = 'qr_token'
export const QUERY_PARAM_KEY_SELECTED_DOCUMENT_TYPE = 'selectedDocumentType'
export const QUERY_PARAM_KEY_MOBILE_CARRIER_SCANNED = 'mobile-carrier-scanned'

// verification method constants
// this methods are not using (id scan, go.cam)
export const VERIFICATION_METHOD_ID_SCAN = 'id_scan'
export const VERIFICATION_METHOD_FACIAL_AGE_ESTIMATION = 'facial_age_estimation'
//
export const VERIFICATION_METHOD_MOBILE_CARRIER = 'mobile_carrier'
export const VERIFICATION_METHOD_YOTI_APP_REDIRECT = 'yoti_app'
export const VERIFICATION_METHOD_YOTI_ID_SCAN_REDIRECT = 'yoti_id_scan'
export const VERIFICATION_METHOD_YOTI_AGE_ESTIMATION_REDIRECT = 'yoti_age_estimation'

// confirm modal types
export const CONFIRM_MODAL_TYPE_SWITCH_TO_MOBILE_DATA = 'switch_to_mobile_data'
export const CONFIRM_MODAL_TYPE_MOBILE_DATA_NOT_DETECTED = 'mobile_data_not_detected'
export const CONFIRM_MODAL_TYPE_VERIFICATION_METHOD_MOBILE_CARRIER = 'confirm_modal_mobile_carrier_verification_method'
export const CONFIRM_MODAL_TYPE_MOBILE_CARRIER_VERIFICATION_METHOD = 'mobile_carrier_verification_method'
export const CONFIRM_MODAL_TYPE_MOBILE_VERIFICATION_PLATFORM = 'mobile_verification_platform'
export const CONFIRM_MODAL_TYPE_VERIFYING_ON_MOBILE = 'verifying_on_mobile'

// ID scan document types

export const ID_SCAN_DOCUMENT_TYPES = [
   {
      name: "Driver’s License or USA State identification Card",
      value: 'id',
      iconName: 'driver-license',
      documentTypeId: 1,
      steps: [
         {
            index: 1,
            img: null,
            blob: {},
            type: 'front',
            isAuto: false,
            source: "file",
         },
      ],
   },
   {
      name: 'Passport (all countries)',
      value: 'passport',
      iconName: 'passport',
      documentTypeId: 2,
      steps: [
         {
            index: 1,
            img: null,
            blob: {},
            type: 'mrz',
            isAuto: false,
            source: "file",
         },
      ],
   },
   {
      name: 'USA Passport card',
      value: 'passport_card',
      iconName: 'passport-card',
      documentTypeId: 3,
      steps: [
         {
            index: 1,
            img: null,
            blob: {},
            type: 'front',
            isAuto: false,
            source: "file",
         },
      ],
   },
   {
      name: 'International ID',
      value: 'international_id',
      iconName: 'id-card',
      documentTypeId: 7,
      steps: [
         {
            index: 1,
            img: null,
            blob: {},
            type: 'front',
            isAuto: false,
            source: "file",
         },
         {
            index: 2,
            img: null,
            blob: {},
            type: 'mrz',
            isAuto: false,
            source: "file",
         },
      ],
   },
]
